import React, { useState, useEffect } from "react";
import { Container, Spinner, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { useTimer } from 'react-timer-hook';

import classNames from "classnames";
import moment     from 'moment';
import Cookies    from 'js-cookie';

import CheckIn  from "~/services/checkIn";

import OverlayModal        from "~/components/overlayModal";
import CircularProgressbar from "~/components/progressBar";
import ModalClaimed        from "./Modal/Claimed";

import ApplixirVideo   from "./Types/Video";
import HCaptcha        from "./Types/Hcaptcha";
import CheckInProgress from "./CheckInProgress";

const CheckInPage = ({})=> {


  const [loading     , setLoading]     = useState(false);
  const [percentage  , setPercentage]  = useState(0);

  const [overlayOpen , setOverlayOpen] = useState(false);
  const [overlayType , setOverlayType] = useState("");

  const [checkinTimeout , setCheckinTimeout] = useState(Cookies.get('checkin-timeout'));
  const [checkinType    , setCheckinType]    = useState('hcaptcha');
  const [isError        , setIsError]        = useState(false);
  const [message        , setMessage]        = useState("");

  const [rewards        , setRewards]        = useState([]);
  const [progress       , setProgress]       = useState(0);

  const { seconds, minutes, restart } = useTimer({ expiryTimestamp: moment.unix(checkinTimeout).toDate() });

  const isDisabled = Boolean(loading || minutes || seconds);

  useEffect(()=> restart(moment.unix(checkinTimeout).toDate()), [checkinTimeout]);

  useEffect(()=> {
    (async() => {
      verifyCheckIn();
      setRewards(await CheckIn.getRewards());
      setProgress(await CheckIn.getProgress());
    })()
  }, []);

  const verifyCheckIn = async ()=> {
    const response = await CheckIn.bonusCheck();
    setPercentage(response.todayPercentage * 100);
    setProgress(await CheckIn.getProgress());

    response.nextCheckin && addCheckinTimeout(response.nextCheckin);
    response.todayPercentage == 1 && setMessage("Bonus granted for today!");
  };

  const addCheckinTimeout = (timestamp)=> {
    Cookies.set("checkin-timeout", timestamp, { expires: moment.unix(timestamp).toDate() });
    setCheckinTimeout(timestamp);
  };

  const claimCheckIn = ()=> {
    if(isDisabled) return;
    setOverlayType('show');
    setOverlayOpen(true);
  };
  
  return (
    <Container className="check-in-page">

      <h1 className="main-title">Check-in Bonus</h1>

      <div className="today-progress">
        <CircularProgressbar gradientId="progress" percentage={percentage} startColor="#f77b7c" endColor="#f4c663" strokeWidth="6">

          { percentage == 100 ? <div className="p-2 text-success"> { message } </div>  :

          ( minutes != 0 && seconds != 0 ? (<div className="timer">
            <p> <strong> {minutes < 10 ? '0' : ''}{minutes}:{seconds < 10 ? '0' : ''}{seconds} </strong> </p>
            <span>Until next checkin  </span>
          </div>) : <cite className="completed"> {percentage}% </cite> ) }

        </CircularProgressbar>
      </div>

      { percentage < 100 && <div className='text-center'>

        <h6> Earn 10 points by succesfully completing the { checkinType }, the offer is available everyday and you can view a max of 4 videos/day </h6>

        <CheckInProgress rewards={rewards} progress={progress} />

        <Button block color="primary" className={classNames({disabled: isDisabled })} disabled={isDisabled} onClick={claimCheckIn}>
          { !loading && 'Claim Bonus' }
          {  loading && <Spinner size="sm" /> }
        </Button>
      </div>
      }

      {isError && <div className="text-center m-t-10"> <h6 className="text-danger"> { isError ? (message.error || message.token || message.generalError) : ""} </h6> <hr/> </div> }

      { percentage === 100 && message && <div className="text-center m-t-10">
      
        <CheckInProgress rewards={rewards} progress={progress} />

        <p style={{marginTop: "20px"}}>
          Do you know to earn even more points easily? <br/>
          Go to the Surveys section and check the offerwall available. You can earn more than <strong>100.000 points</strong> every day! 💰
        </p>

        <Link to={"/surveys"}> <Button block color="pitch">Go to Surveys </Button> </Link>
      </div> }

      { overlayType == "claimed" && <OverlayModal opened={overlayOpen}>
        <ModalClaimed isError={isError} message={message} overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} />
      </OverlayModal> }

      { overlayType == "show" && <OverlayModal opened={overlayOpen} instant bg={checkinType == 'video' ? 'transparent' : "white"}>
        { checkinType == 'video'    && <ApplixirVideo { ...{setLoading, setMessage, setCheckinType, verifyCheckIn, setOverlayType, overlayOpen, setOverlayOpen} } /> }
        { checkinType == 'hcaptcha' && <HCaptcha      { ...{setLoading, setMessage, setCheckinType, verifyCheckIn, setOverlayType, addCheckinTimeout, setIsError }} /> }
      </OverlayModal> }

    </Container>
  );
}

export default CheckInPage;
